import React, { useEffect, useState } from "react";
import { FileText, Plus, Trash2 } from "lucide-react";
import { api, errorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import { useI18n } from "@/lib/i18n";

const VARS = ["{prénom}", "{nom}", "{poste}", "{entreprise}", "{nom_recruteur}", "{entreprise_recruteur}"];

export function TemplatesManager() {
  const { t } = useI18n();
  const [rows, setRows] = useState([]);
  const [edit, setEdit] = useState(null);
  const load = () => api.get("/mail/templates").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);
  const save = async () => {
    try {
      if (edit.id) await api.put(`/mail/templates/${edit.id}`, edit); else await api.post("/mail/templates", edit);
      toast.success(t("Saved")); setEdit(null); load();
    } catch (e) { toast.error(errorDetail(e)); }
  };
  const del = async (tpl) => { await api.delete(`/mail/templates/${tpl.id}`); load(); };
  return (
    <div className="card-surface p-5 mb-6 space-y-3" data-testid="templates-manager">
      <div className="flex items-center justify-between"><div className="font-semibold text-sm flex items-center gap-2"><FileText className="w-4 h-4 text-primary" />{t("Message templates")}</div>
        <Button size="sm" variant="outline" onClick={() => setEdit({ name: "", subject: "", body: "" })} data-testid="template-new"><Plus className="w-4 h-4" />{t("New template")}</Button></div>
      <div className="flex flex-wrap gap-2">{rows.map((tpl) => (
        <div key={tpl.id} className="flex items-center gap-1 rounded-md border px-2 py-1 text-xs">
          <button onClick={() => setEdit(tpl)} data-testid={`template-${tpl.id}`}>{tpl.name}</button>
          <button onClick={() => del(tpl)} aria-label={t("Delete")} className="text-muted-foreground hover:text-red-600" data-testid={`template-delete-${tpl.id}`}><Trash2 className="w-3 h-3" /></button>
        </div>))}</div>
      {edit && (
        <div className="space-y-2" data-testid="template-editor">
          <Input placeholder={t("Template name")} value={edit.name} onChange={(e) => setEdit({ ...edit, name: e.target.value })} data-testid="template-name" />
          <Input placeholder={t("Subject")} value={edit.subject} onChange={(e) => setEdit({ ...edit, subject: e.target.value })} data-testid="template-subject" />
          <Textarea rows={7} value={edit.body} onChange={(e) => setEdit({ ...edit, body: e.target.value })} data-testid="template-body" />
          <div className="flex flex-wrap gap-1 text-[11px]" translate="no">{VARS.map((v) => <button key={v} type="button" className="rounded bg-muted px-1.5 py-0.5 font-mono" onClick={() => setEdit({ ...edit, body: `${edit.body}${v}` })}>{v}</button>)}</div>
          <div className="flex gap-2"><Button size="sm" disabled={!edit.name || !edit.subject || !edit.body} onClick={save} data-testid="template-save">{t("Save")}</Button><Button size="sm" variant="outline" onClick={() => setEdit(null)} data-testid="template-cancel">{t("Cancel")}</Button></div>
        </div>
      )}
    </div>
  );
}
